<template>
  <main-layout>
    <div class="payMealBox">
      <img class="img" src="https://image.manamana.net/1653018922000_OKdXuIhZ" alt="">
      <div class="payMeal">
        <div class="title">{{$t('recruit.招聘套餐')}}</div>
        <div class="weixin">{{$t('recruit.有任何疑问可联系客服，微信号：')}}manamananet</div>
        <div class="listBox clearfix">
          <div
            :class="['list',index==i?'list1':'']"
            v-for="(item,i) in list"
            :key="i"
            @mouseenter="index = i"
            @mouseleave="index = null"
          >
            <div :class="'line' + i"></div>
            <div :class="['type','type' + i]">{{item.comboName}}</div>
            <div class="title1">{{$t('recruit.基本权益')}}</div>
            <div class="title2 clearfix">
              {{$t('recruit.发布职位数')}}
              <span>
                <i class="number">{{item.recruitCount > 0 ? item.recruitCount: $t('recruit.无限制')}}</i>
                <i class="company">{{getType(i + 1,2)}}</i>
              </span>
            </div>
            <div class="title3">
              <span></span>
              <i>{{$t('recruit.增益权限')}}</i>
              <span></span>
            </div>
            <div v-if="i==0 || i == 4">
              <div class="title4">
                <img src="https://image.manamana.net/1652342143000_nqIqtsVH" alt="">公众号：首条合集收录
              </div>
              <div class="title4">
                <img src="https://image.manamana.net/1652342143000_nqIqtsVH" alt="">公众号：次条单发1次
              </div>
              <div class="title4">
                <img src="https://image.manamana.net/1652342143000_nqIqtsVH" alt="">PC首页banner第二帧
              </div>
              <div class="title4">
                <img src="https://image.manamana.net/1652342143000_nqIqtsVH" alt="">APP开屏页
              </div>
            </div>
            <div v-if="i==1">
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：首条合集收录（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：次条单发1次（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">PC首页banner第二帧 3天（前20位）
              </div>
              <div class="title4">
                <img src="https://image.manamana.net/1652342143000_nqIqtsVH" alt="">APP开屏页
              </div>
            </div>
            <div v-if="i==2">
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：首条合集收录（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：次条单发1次（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">PC首页banner第二帧 3天（前20位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">APP开屏页：1天（前50位）
              </div>
            </div>
            <div v-if="i==3">
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：首条合集收录（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">公众号：次条单发1次（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">PC首页banner第二帧 3天（前20位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">APP开屏页：1天（前50位）
              </div>
              <div class="title5">
                <img src="https://image.manamana.net/1652342041000_KtFLxundefinedAL" alt="">招聘类活动参与福利
              </div>
            </div>
            
            <div class="butPosition">
              <div :class="['price',i == 0? 'price1':'']">
                {{item.price ? item.price : $t('recruit.免费')}}
                <i>{{getType(i+1,3)}}</i>
              </div>
              <div
                class="but"
                @click="isShowPop1(item)"
                v-if="item.id !== comboId && item.id > comboId"
              >{{i == 4 ? $t('recruit.购买加油包'): i == 0 ? $t('recruit.使用套餐') : $t('recruit.购买套餐')}}</div>
              <div class="goPay" v-if="item.id !== comboId && item.id < comboId && item.id !== 1">{{$t('recruit.去购买')}}</div>
              <div class="inUse" v-if="item.id == comboId">{{$t('recruit.使用中')}}</div>
            </div>
            <img
              v-if="item.id == comboId"
              class="inUseImg"
              src="https://image.manamana.net/1652343990000_bGyXUnLE"
              alt
            />
          </div>
        </div>
        <div class="textBox">
          <p>Tips：</p>
          <p>套餐内职位数用完时，可购买加油包来增加职位数，加油包可和套餐叠加使用，也可以购买多个加油包叠加使用；也可以升级年度套餐，如需升级请联系客服微信：manamananet</p>
        </div>
      </div>
    </div>
    <div class="popBox" v-if="isShow1">
      <div class="box">
        <div class="title">
          {{$t('recruit.升级套餐')}}
          <span @click="close1"></span>
        </div>
        <div class="contentBox">{{$t('recruit.升级套餐请联系客服微信：')}}manamananet</div>
        <div class="but">
          <span @click="close1">{{$t('recruit.我知道了')}}</span>
        </div>
      </div>
    </div>
    <div class="popBox" v-if="isShow2">
      <div class="box">
        <div class="title">
          {{$t('recruit.温馨提示')}}
          <span @click="close2"></span>
        </div>
        <div class="contentBox">{{$t('recruit.您尚有未用完的职位数，请使用完后再购买')}}</div>
        <div class="but">
          <span @click="close2">{{$t('recruit.我知道了')}}</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "payMeal",
  metaInfo() {
    return {
      title: "MANA " + this.$t("recruit.购买套餐")
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      list: [],
      index: null,
      isShow1: false,
      isShow2: false,
      comboId: null
    };
  },
  created() {
    this.getList();
    this.getcombo();
  },
  methods: {
    getList() {
      this.$http.get("/api/recruit/combo/").then(res => {
        if (res.code == "OK") {
          this.list = res.data.reverse();
        }
      });
    },
    getcombo() {
      this.$http.get("/api/u/recruit/combo/current").then(res => {
        if (res.code == "OK") {
          if (res.data && res.data.comboId) {
            this.comboId = res.data.comboId;
          }
        }
      });
    },
    isShowPop1(item) {
      if (item.type == 3) {
        this.$router.push("/MyRecruit?type=1&click=true");
        return;
      }
      let params = {
        comboId: item.id
      };
      this.$http
        .post("/api/u/recruit/combo/check", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            if (res.data.countUnUsed == 2 && res.data.upgrade == 2) {
              this.$router.push("/live/payDetail?id=" + item.id + "&type=3");
            }
            if (res.data.upgrade == 1) {
              this.isShow1 = true;
            }
            if (res.data.countUnUsed == 1) {
              this.isShow2 = true;
            }
          }
        });
    },
    close1() {
      this.isShow1 = false;
    },
    isShowPop2() {
      this.isShow2 = true;
    },
    close2() {
      this.isShow2 = false;
    },
    getType(type, index) {
      if (index == 2) {
        if (type == 1) {
          return this.$t("recruit.个/年");
        }
        if (type == 2) {
          return this.$t("recruit.个/年");
        }
        if (type == 3) {
          return this.$t("recruit.个/年");
        }
        if (type == 4) {
          return "";
        }
        if (type == 5) {
          return this.$t("recruit.个/月");
        }
      }
      if (index == 3) {
        if (type == 1) {
          return "";
        }
        if (type == 2) {
          return this.$t("recruit.元/年");
        }
        if (type == 3) {
          return this.$t("recruit.元/年");
        }
        if (type == 4) {
          return this.$t("recruit.元/年");
        }
        if (type == 5) {
          return this.$t("recruit.元/月");
        }
      }
    }
  },
  watch: {},
  computed: {
    language() {
      return this.$language();
    }
  }
};
</script>

<style lang="stylus" scoped>
.payMealBox{
  .img{
    width: 100%;
    height: 264px;
  }
  .payMeal {
    width: 1110px;
    margin: -175px auto 0;
    padding: 90px 0;

    .title {
      text-align: center;
      height: 42px;
      font-size: 30px;
      font-weight: 600;
      color: #333333;
      line-height: 42px;
    }

    .weixin {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-top: 20px;
      text-align: center;
    }

    .listBox {
      margin-top: 40px;

      .list {
        float: left;
        width: 206px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(32, 38, 204, 0.1);
        border-radius: 4px;
        margin-right: 20px;
        padding: 0 10px 18px;
        position: relative;
        cursor: pointer;
        min-height: 422px;
        box-sizing: border-box;
        height: 470px;
        &:nth-child(5) {
          margin-right: 0;
        }

        .line0 {
          height: 8px;
          background: #A0A0A0;
          border-radius: 4px 4px 0px 0px;
          position: absolute;
          width: 206px;
          left: 0;
          top: 0;
        }

        .line1 {
          height: 8px;
          background: #4DBEA7;
          border-radius: 4px 4px 0px 0px;
          position: absolute;
          width: 206px;
          left: 0;
          top: 0;
        }

        .line2 {
          height: 8px;
          background: #4EAFBE;
          border-radius: 4px 4px 0px 0px;
          position: absolute;
          width: 206px;
          left: 0;
          top: 0;
        }

        .line3 {
          height: 8px;
          background: #4E89BF;
          border-radius: 4px 4px 0px 0px;
          position: absolute;
          width: 206px;
          left: 0;
          top: 0;
        }

        .line4 {
          height: 8px;
          background: #3971C7;
          border-radius: 4px 4px 0px 0px;
          position: absolute;
          width: 206px;
          left: 0;
          top: 0;
        }

        .type {
          margin-top: 28px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          text-align: center;
        }

        .type0 {
          color: #A0A0A0;
        }

        .type1 {
          color: #4DBEA7;
        }

        .type2 {
          color: #4EAFBE;
        }

        .type3 {
          color: #4E89BF;
        }

        .type4 {
          color: #3870C7;
        }

        .title1 {
          margin-top: 20px;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }

        .title2 {
          margin-top: 10px;
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;

          span {
            float: right;

            .number {
              font-size: 18px;
              font-weight: 500;
              color: #333333;
            }

            .company {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }
          }
        }

        .title3 {
          margin-top: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;

          i {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin: 0 10px;
          }

          span {
            display: inline-block;
            width: 46px;
            height: 1px;
            border-top: 1px solid #D8D8D8;
            vertical-align: middle;
          }
        }

        .title4 {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;

          img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
            margin-bottom: 3px;
          }
        }

        .title5 {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 18px;

          img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
            margin-bottom: 3px;
          }
        }

        .butPosition{
          position: absolute;
          bottom: 18px;
          left: 50%;
          transform: translateX(-50%);
          .price {
            margin-top: 20px;
            font-size: 18px;
            font-weight: 600;
            line-height: 22px;
            color: #FF2A00;
            text-align: center;

            i {
              font-size: 12px;
              font-weight: 400;
              color: #FF2A00;
            }
          }

          .price1 {
            font-size: 16px;
            font-weight: 600;
            color: #999999;
          }

          .but {
            margin: 20px auto 0;
            width: 120px;
            height: 32px;
            line-height: 32px;
            background: #2026CC;
            border-radius: 4px;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
          }

          .goPay {
            width: 120px;
            height: 32px;
            line-height: 32px;
            background: rgba(32, 38, 204, 0.5);
            border-radius: 4px;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            margin: 20px auto 0;
          }

          .inUse {
            margin: 20px auto 0;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #2026CC;
          }
        }

        .inUseImg {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 28px;
          height: 28px;
        }
      }

      .list1 {
        top: -10px;
      }
    }
    .textBox{
      font-weight: 400;
      line-height: 28px;
      margin-top: 40px;
      font-size: 14px;
      color: #333333;
    }
  }
}


.popBox {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 111;

  .box {
    width: 540px;
    padding-bottom: 40px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    .title {
      text-align: center;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      position: relative;

      span {
        position: absolute;
        color: #999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .contentBox {
      padding: 28px 30px 50px;
      height: 28px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align: center;
    }

    .but {
      text-align: center;

      span {
        padding: 0 35px;
        hight: 40px;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payMeal/home.vue